import { Drawer, StackNavigation } from '@10d/tend-ui-primitives';
import { useTheme } from '@10d/tend-ui-theme';
import React from 'react';
import { Menu, ArrowBack } from '@10d/tend-ui-icons';
import { Box } from '@10d/tend-ui-grid';
import { Title } from '@10d/tend-ui-typography';
import { UNSTABLE_useControllableStateV2 } from '@10d/tend-ui-hooks';
import { Button } from './styled.js';

/**
 * Внутренний компонент для нужд дизайн системы
 */
const DrawerBurgerMenu = ({ title, navigation, onClose, open, defaultOpen, header, footer, onOpenChange, }) => {
    const theme = useTheme();
    const [__open, __setOpen] = UNSTABLE_useControllableStateV2({
        value: open,
        defaultValue: defaultOpen,
        onChange: state => {
            onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(state);
            if (state === false) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: 'button', onClick: () => {
                __setOpen(p => !p);
            }, theme: theme, "$selected": __open },
            React.createElement(Menu, { size: 24, color: 'gray0' })),
        React.createElement(Drawer.Root, { open: __open, fullscreen: { offset: '0px' }, placement: 'right', backgroundColor: 'gray50', onClose: () => {
                __setOpen(false);
            } },
            React.createElement(Drawer.Header, null,
                React.createElement(Box, { "$display": 'flex', "$alignItems": 'center', "$gap": 8 },
                    React.createElement(ArrowBack, { onClick: () => {
                            __setOpen(false);
                        }, size: 24, color: 'gray900' }),
                    React.createElement(Title, { margin: '0', level: 'h6' }, title))),
            React.createElement(Drawer.Body, null,
                React.createElement(Box, { "$display": 'flex', "$flexDirection": 'column', "$gap": 16 },
                    header,
                    navigation && React.createElement(StackNavigation, Object.assign({}, navigation)),
                    footer)))));
};
DrawerBurgerMenu.displayName = 'DrawerBurgerMenu';

export { DrawerBurgerMenu };
